export const NO_ORDERING = 2;
export type NoOrdering = typeof NO_ORDERING;
